export const initialAbility = [
  {
    action: 'read',
    subject: 'Auth',
  },
]

export const signinUserAbility = [
  {
    action: 'manage',
    subject: 'all',
  },
]


export const _ = undefined
